module.exports = __webpack_public_path__ + "img/full1-min.3de9bd75.png";